export default __webpack_public_path__ + "static/media/blimus.00e58c04.jpg";